import type { MessageReaction } from '../avroom/types';

export enum emojisReaction {
  UPVOTED = 'thumbsup',
  ANSWERED = 'thumbsdown',
  APPROVED = 'ok_hand',
  PRIORITIZED = 'high_brightness'
}

export interface TextQNAPost {
  readonly id: string;
  readonly text: string;
  readonly mmidOfWhoPosted: string;
  readonly createdAt: number; // Unix timestamp in milliseconds
  updatedAt: number; // Unix timestamp in milliseconds
  reactions: MessageReaction[];
  root_id?: string;
  props: any;
  identifiers: any;
}

export enum filterMode {
  ALL = 'all',
  ANSWERED = 'answered',
  UNANSWERED = 'unanswered',
  PRIORITIZED = 'prioritized',
  APPROVED = 'approved',
  UNAPPROVED = 'unapproved',
  MYQUESTIONS = 'myquestions',
  UNANSWEREDANDUNAPPROVED = 'unansweredandunapproved',
  UNASSIGNED = 'unassigned'
}

export enum sortMode {
  UPVOTES = 'upvotes',
  RECENT = 'recent'
}

export interface TextQNAQuestionDetails {
  questionText: string;
  id: string;
  upvotedByUser: boolean;
  totalUpvotes: number;
  time: string;
  totalOkHand: number;
  approvedByMods: boolean;
  answered: boolean;
  created_at: number;
  user: {
    name: string;
    id: string;
    mediumimage: string;
    thumbnail: string;
    is_in_person?: boolean;
  };
  answer?: string;
  answerId?: string;
  answeredByUser: {
    name: string;
    id: string;
    mediumimage: string;
    thumbnail: string;
    is_in_person?: boolean;
  };
  isPrioritized: boolean;
  props?: {
    isDeleted: boolean;
    assignedTo?: string;
  };
}

export interface TextQADetail {
  questions: TextQNAQuestionDetails[];
  numberOfUserUnModdedQues: number;
  publishedQuestion: TextQNAQuestionDetails | null;
  totalNoOfQuestions: number;
}

export interface TextQNAChannel {
  id: string;
  olderPostsPresent: boolean;
  qnaState: 'loading' | 'loadingError' | 'loaded' | 'initializationError';
  sortmode: {
    label: string;
    value: sortMode;
  };
  filtermode: {
    label: string;
    value: filterMode;
  };
  speakerFilter: {
    label: string;
    value: string;
  };
  isModerated: boolean;
  isAskAnonymouslyChecked: boolean;
  detail: TextQADetail;
  textQNAAnswerMeta: {
    showAnswerersIdentity: Boolean;
    answerersAlias: String;
  };
}

export interface TextQNAState {
  textQnA: TextQNAChannel | null;
  jitterdelay: number;
  channel_loading: Record<string, 'left' | 'loading' | 'loaded' | 'loaderror'>;
  scheduleTextQARefresh: boolean;
}

export interface Filters {
  sortingOptions: FilterItem[];
  filteringOptions: FilterItem[];
}

export interface FilterItem {
  label: string;
  value: string;
}
